import { ReactElement, useEffect, useState } from "react";
import Dirs from "../../fmanlibs/Dirs";
import { FMFile } from "../../shared/FMFile";
import FManApi from "../../fmanlibs/FManApi";
import TextContent from "./TextContent";
import ImageContent from "./ImageContent";
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import Loading from "../../gui/Loading/Loading";
import CloseIcon from "../../gui/Icons/CloseIcon";
import IconButton from "../../gui/Button/IconButton";
import { useFilesProvider } from "../../fmanlibs/FilesProvider";
import { usePath } from "../../libs/path/PathProvider";
import VideoContent from "./VideoContent";
import AudioContent from "./AudioContent";

const DIALOG_ID="preview"

export function PreviewDlg(props:{file:FMFile}) {
    const {file} = props
    const [content,setContent] = useState<string|null>(null)
    const [url,setUrl] = useState<string|null>(null)
    const parent = Dirs.i.findNode(file.parentId!)
    const filename = (parent?.path||"")+"/"+file.name
    const {addSnackbar} = useSnackbar()
    const {popOverlay} = useOverlay()
    
    let preview :ReactElement|null = null
    if (content!==null) preview = <TextContent text={content}/>
    else if (url!==null) {
        if (FMFile.isVideo(file)) preview = <VideoContent url={url}/>
        else if (FMFile.isAudio(file)) preview = <AudioContent url={url}/>
        else preview = <ImageContent url={url}/>
    }
    else preview = <Loading className="mt-32"/>

    const onError = (e:any) => {
        addSnackbar(e)
        popOverlay(DIALOG_ID)
    }
    useEffect(() => {
        if (FMFile.isText(file)) FManApi.i.getContent(file._id).then(content => setContent(content)).catch(onError)
        else FManApi.i.shareFiles([file._id], 1).then(url => setUrl(url)).catch(onError)
    }, [])
    return <>
        <div className="header flex middle between"><div className="name">{filename}</div><IconButton onClick={_ => popOverlay(DIALOG_ID)}><CloseIcon/></IconButton></div>
        <div className="content">{preview}</div>
    </>
}
export default function usePreviewDlg(){
    const {addOverlay,hasOverlay} = useOverlay()
    const {files} = useFilesProvider()
    const {setHash} = usePath()

    const afterClosed = () => setHash("")
    const openPreview = (fileId:string) => {
        const file = files.find(f => f._id==fileId)
        if (!file || hasOverlay(DIALOG_ID)) return

        addOverlay("preview", {children:<PreviewDlg file={file}/>, afterClosed, className:FMFile.isAudio(file) ? "dialog" : "fullscreen"})
    }
    return {openPreview}
}